import React from 'react';
import {
    Text,
    Button,
    Flex,
    useColorMode,
    Skeleton,
    SkeletonText
} from '@chakra-ui/react';
import Card from "components/Card/Card";

import axios from 'axios';

import apiUrl from "../../../variables/api";
import { toast } from 'react-toastify';

function Page() {
    const { colorMode } = useColorMode();
    const [data, setData] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        axios.get(apiUrl + '/data/jrg-sum', {
            headers: { 'x-access-token': localStorage.getItem('token') }
        }).then(res => {
            setData(res.data);
            setIsLoading(false);
            console.log(res.data);
        }).catch(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <Flex pt={{ base: "120px", md: "75px" }} direction={'column'} gap={5}>
            <Card>
                <Flex justifyContent={"center"} alignItems={"center"} direction={"column"}>
                    <Skeleton isLoaded={!isLoading}>
                        <Text as='b' fontSize='2xl'>Podgląd raportów jednostek</Text>
                    </Skeleton>
                    <SkeletonText isLoaded={!isLoading} noOfLines={1} spacing="4">
                        <Text fontWeight={"bold"} fontSize='xl'>Dane za okres (#{data?.period}) {data?.periodDate}</Text>
                    </SkeletonText>
                    {data?.dataOne && data?.dataTwo && (
                        <Button
                            colorScheme="red"
                            mt={5}
                            isLoading={isLoading}
                            onClick={() => {
                                axios.post(apiUrl + '/data/jrg-send', "senddata", {
                                    headers: { 'x-access-token': localStorage.getItem('token') }
                                })
                                .then(response => {
                                    toast.success('Pomyślnie wysłano raport!');
                                    console.log('Data sent successfully:', response.data);
                                })
                                .catch(error => {
                                    console.error('There was an error sending the data!', error);
                                });
                            }}
                        >
                            Wyślij
                        </Button>
                    )}
                </Flex>
            </Card>
            <Flex direction={{sm: 'column', md: 'row'}} gap={5}>
                <Card>
                    <Skeleton isLoaded={!isLoading}>
                        <Text as='b' fontSize={'xl'}>JRG 1</Text>
                    </Skeleton>
                    <Flex direction={'column'} gap={2}>
                        {isLoading ? (
                            <SkeletonText noOfLines={10} spacing="4" />
                        ) : (
                            data?.dataOne && (
                                <Text whiteSpace="pre-line">
                                    Okres rozliczeniowy {data.periodDate}{"\n\n"}
                                    W ww. okresie rozliczeniowym potencjał ratowniczy jednostki stanowiło {data.dataOne.vehiclesTotal} pojazdów w tym{"\n"}
                                    {data.dataOne.fireVehicles} pojazdów gaśniczych,{"\n"}
                                    {data.dataOne.specialistVehicles} pojazdów specjalistycznych,{"\n"}
                                    {data.dataOne.aircrafts} statków powietrznych/dronów,{"\n"}
                                    {data.dataOne.watercrafts} pojazdów pływajacych.{"\n\n"}
                                    Ilość dyspozycji do zdarzeń: {data.dataOne.dispatches}{"\n"}
                                    Ilość wyjazdów grup specjalistycznych stacjonujących na terenie jednostki: {data.dataOne.sgrtDispatches + data.dataOne.sgchemDispatches + data.dataOne.sgrmedDispatches} w tym:{"\n"}
                                    SGRT: {data.dataOne.sgrtDispatches},{"\n"}
                                    SGRChem: {data.dataOne.sgchemDispatches},{"\n"}
                                    SGRMed: {data.dataOne.sgrmedDispatches}.{"\n\n"}
                                    Najbardziej eksploatowany pojazd: {data.dataOne.mostUsedVehicle}{"\n"}
                                    Najmniej eksploatowany pojazd: {data.dataOne.leastUsedVehicle}{"\n\n"}
                                    Ilość zdarzeń z udziałem pojazdów służbowych (wypadki/kolizje): {data.dataOne.incidentsWithServiceVehicles}{"\n"}
                                    Ilość usterek w sprzęcie ratowniczym: {data.dataOne.equipmentFailures}{"\n"}
                                    Pojazdy/sprzęt wycofany z podziału bojowego w okresie rozliczeniowym: {data.dataOne.withdrawnEquipment}
                                </Text>
                            )
                        )}
                    </Flex>
                </Card>
                <Card>
                    <Skeleton isLoaded={!isLoading}>
                        <Text as='b' fontSize={'xl'}>JRG 2</Text>
                    </Skeleton>
                    <Flex direction={'column'} gap={2}>
                        {isLoading ? (
                            <SkeletonText noOfLines={10} spacing="4" />
                        ) : (
                            data?.dataTwo && (
                                <Text whiteSpace="pre-line">
                                    Okres rozliczeniowy {data.periodDate}{"\n\n"}
                                    W ww. okresie rozliczeniowym potencjał ratowniczy jednostki stanowiło {data.dataTwo.vehiclesTotal} pojazdów w tym{"\n"}
                                    {data.dataTwo.fireVehicles} pojazdów gaśniczych,{"\n"}
                                    {data.dataTwo.specialistVehicles} pojazdów specjalistycznych,{"\n"}
                                    {data.dataTwo.aircrafts} statków powietrznych/dronów,{"\n"}
                                    {data.dataTwo.watercrafts} pojazdów pływajacych.{"\n\n"}
                                    Ilość dyspozycji do zdarzeń: {data.dataTwo.dispatches}{"\n"}
                                    Ilość wyjazdów grup specjalistycznych stacjonujących na terenie jednostki: {data.dataTwo.sgprDispatches} w tym:{"\n"}
                                    SGPR: {data.dataTwo.sgprDispatches}.{"\n\n"}
                                    Najbardziej eksploatowany pojazd: {data.dataTwo.mostUsedVehicle}{"\n"}
                                    Najmniej eksploatowany pojazd: {data.dataTwo.leastUsedVehicle}{"\n\n"}
                                    Ilość zdarzeń z udziałem pojazdów służbowych (wypadki/kolizje): {data.dataTwo.incidentsWithServiceVehicles}{"\n"}
                                    Ilość usterek w sprzęcie ratowniczym: {data.dataTwo.equipmentFailures}{"\n"}
                                    Pojazdy/sprzęt wycofany z podziału bojowego w okresie rozliczeniowym: {data.dataTwo.withdrawnEquipment}
                                </Text>
                            )
                        )}
                    </Flex>
                </Card>
            </Flex>
        </Flex>
    );
}

export default Page;
